import { template3Config } from './config';

// Persisted arrays replace reducer defaults. Append the new template without
// discarding existing customizations, versions or the user's active template.
export const addTemplateThree = state => {
    if (!state?.pdfTemplate || state.pdfTemplate.templates?.some(item => item.template_name === 'template_3')) return state;
    return {
        ...state,
        pdfTemplate: {
            ...state.pdfTemplate,
            templates: [
                ...(state.pdfTemplate.templates || []),
                { label: 'Template 3', template_name: 'template_3', version: '1.00', ...template3Config },
            ],
            versions: { ...state.pdfTemplate.versions, template_3: 1.00 },
        },
    };
};
